import i18next from 'i18next';

/**
 * Build the display name of a parent row in the "elements using this recipe/ingredient" tabs.
 *
 * Shared by the recipe and ingredient detail pages so the variant labelling stays in sync:
 *   - "Recipe (variant)" for a row tied to a named variant,
 *   - "Recipe (Recette principale)" for the base composition of a recipe that has variants,
 *   - the plain name otherwise.
 *
 * @param {{ name: string, variantName?: string | null, hasVariants?: boolean }} item
 * @returns {string}
 */
export function getParentDisplayName(item) {
  if (item.variantName != null) {
    return `${item.name} (${item.variantName})`;
  }

  if (item.hasVariants) {
    return `${item.name} (${i18next.t('ADMIN.RECIPES.MAIN_RECIPE_TAB')})`;
  }

  return item.name;
}
